import React, { useState } from "react";
import styles from "../styles/ValidatorDashboard.module.css";
import { dummyBlocks } from "../data/dummyBlocks3";
import CryptoJS from "crypto-js";
export default function ValidatorDashboard() {
  const [view, setView] = useState("pending");
  const [validatedBlocks, setValidatedBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [checklistOpen, setChecklistOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);

  const [expandedHash, setExpandedHash] = useState(null);

  const handleValidate = (block) => {
    setSelectedBlock(block);
    setChecklistOpen(true);
  };


  const truncateHash = (hash, id) => {
    if (!hash) return "";
    if (expandedHash === id) return hash;
    return hash.length > 12 ? `${hash.slice(0, 12)}...` : hash;
  };

  const toggleHash = (id) => {
    setExpandedHash(expandedHash === id ? null : id);
  };




  const [checklist, setChecklist] = useState({
    docAuthenticity: false,
    holderIdentity: false,
    surveyVerified: false,
    documentHash: false,
    payloadIntegrity: false,
    merkleRoot: false,
  
  });

  const [privateKey, setPrivateKey] = useState("");
  const [signature, setSignature] = useState("");

  const completedSteps = Object.values(checklist).filter(Boolean).length;
  const totalSteps = 6;

  const generateSignature = () => {
    if (!privateKey) return alert("Enter your private key to sign");
    // Simple SHA256 signature (replace with proper cryptography in production)
    const signData = dummyBlocks.hash + privateKey;
    const generatedSignature = CryptoJS.SHA256(signData).toString();
    setSignature(generatedSignature);
    alert("Signature generated successfully!");
  };

  const confirmValidation = () => {
    if (completedSteps !== totalSteps) {
      alert("Please complete all validation steps before confirming.");
      return;
    }
    if (!signature) {
      alert("Please generate your signature.");
      return;
    }
    // Call parent callback with signature
    //onValidationComplete(signature);
  };

const checklistItems = [
  { key: "hashVerification", label: "All Hashes Verified" },
  { key: "holderDetails", label: "Holder Details Verified as per Document" },
  { key: "previousUtilization", label: "Previous Utilization Checked" },
  { key: "utilizerDetails", label: "Utilizer Details Verified as per Document" },
  { key: "fsiArea", label: "FSI and Area Verified" },
  { key: "balances", label: "Balances Checked" }
];

// Helper: Checklist tooltips
function getChecklistTooltip(key) {
  const tooltips = {
    hashVerification: "Confirm previous hash, current hash, and document hash are all valid.",
    holderDetails: "Ensure holder details exactly match the provided document.",
    previousUtilization: "Check and validate all records of previous utilization.",
    utilizerDetails: "Verify the utilizer's name, ID, and related details match the document.",
    fsiArea: "Ensure FSI values and total area calculations are correct.",
    balances: "Confirm remaining balances are accurate after utilization."
  };
  return tooltips[key] || "";
}


  const blocksToShow =
    view === "validated"
      ? validatedBlocks
      : dummyBlocks.filter(
        (b) => !validatedBlocks.find((vb) => vb.blockID === b.blockID)
      );

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Validator Dashboard</h2>

      <div className={styles.toggleBar}>
        <button
          className={`${styles.toggleBtn} ${view === "pending" ? styles.active : ""}`}
          onClick={() => setView("pending")}
        >
          Blocks to Validate
        </button>
        <button
          className={`${styles.toggleBtn} ${view === "validated" ? styles.active : ""}`}
          onClick={() => setView("validated")}
        >
          Validated Blocks
        </button>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Block ID</th>
            <th>Timestamp</th>
            <th>Holder</th>
            <th>Land Location</th>
            <th>FSI Credit (sqm)</th>
            <th>Created By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {blocksToShow.map((block) => (
            <tr key={block.blockID}>
              <td>{block.blockID}</td>
              <td>{new Date(block.timestamp).toLocaleString()}</td>
              <td>{block.payload.MainTDR.holderName}</td>
              <td>{block.payload.MainTDR.locationOfLand}</td>
              <td>{block.payload.MainTDR.fsiCreditSqm}</td>
              <td>{block.payload.meta.createdBy}</td>
              <td>
                <button
                  className={styles.detailsBtn}
                  onClick={() => {
                    setSelectedBlock(block);
                    setDetailsOpen(true);
                  }}
                >
                  Details
                </button>
                {view === "pending" && (
                  <button
                    className={styles.validateBtn}
                    onClick={() => handleValidate(block)}
                  >
                    Validate
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Details Modal */}
      {detailsOpen && selectedBlock && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h3 className={styles.modalHeading}>Block Details - {selectedBlock.blockID}</h3>

            <div className={styles.modalGrid}>
              {/* Left Column */}
              <div className={styles.modalColumn}>
                <div className={styles.section}>
                  <h4>Holder Details</h4>
                  <p><strong>Name:</strong> {selectedBlock.payload.MainTDR.holderName}</p>
                  <p><strong>Location:</strong> {selectedBlock.payload.MainTDR.locationOfLand}, {selectedBlock.payload.MainTDR.district}, {selectedBlock.payload.MainTDR.state}</p>
                  <p><strong>Village/City:</strong> {selectedBlock.payload.MainTDR.villageCity}</p>
                  <p><strong>Survey No:</strong> {selectedBlock.payload.MainTDR.surveyNo}</p>
                  <p><strong>FSI Credit:</strong> {selectedBlock.payload.MainTDR.fsiCreditSqm} sqm</p>
                  <p>
                    <strong>Document Hash:</strong>{" "}
                    <span className={styles.hashTruncate} onClick={() => toggleHash("docHash")}>
                      {truncateHash(selectedBlock.payload.MainTDR.documentHash, "docHash")}
                    </span>
                  </p>
                  <p>
                    <strong>Previous Document Hash:</strong>{" "}
                    <span className={styles.hashTruncate} onClick={() => toggleHash("prevDocHash")}>
                      {truncateHash(selectedBlock.previousHash, "prevDocHash")}
                    </span>
                  </p>
                </div>

                <div className={styles.section}>
                  <h4>Block Info</h4>
                  <p>
                    <strong>Current Block Hash:</strong>{" "}
                    <span className={styles.hashTruncate} onClick={() => toggleHash("blockHash")}>
                      {truncateHash(selectedBlock.hash, "blockHash")}
                    </span>
                  </p>
                  <p>
                    <strong>Merkle Root:</strong>{" "}
                    <span className={styles.hashTruncate} onClick={() => toggleHash("merkleRoot")}>
                      {truncateHash(selectedBlock.merkleRoot, "merkleRoot")}
                    </span>
                  </p>
                  <p><strong>Created By:</strong> {selectedBlock.payload.meta.createdBy}</p>
                </div>
              </div>

              {/* Right Column */}
              <div className={styles.modalColumn}>
                <div className={styles.section}>
                  <h4>Documents</h4>
                  <p><strong>Current TDR:</strong> <a href={selectedBlock.documents.currentTDR} target="_blank" rel="noreferrer">View PDF</a></p>
                  <p><strong>Previous TDR:</strong> <a href={selectedBlock.documents.previousTDR} target="_blank" rel="noreferrer">View PDF</a></p>
                </div>

                <div className={styles.section}>
                  <h4>Validators Signatures</h4>
                  {selectedBlock.validatorsSignature.map((v, i) => (
                    <p key={i}>
                      <strong>{v.validatorID}:</strong>{" "}
                      <span className={styles.hashTruncate} onClick={() => toggleHash(v.validatorID)}>
                        {truncateHash(v.signature, v.validatorID)}
                      </span>{" "}
                      ({new Date(v.timestamp).toLocaleString()})
                    </p>
                  ))}
                </div>
              </div>
            </div>

            {/* Full-width Utilisation Table */}
            <div className={styles.section}>
              <h4>Utilisation History</h4>
              <table className={styles.utilisationTable}>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Utilizer</th>
                    <th>Location</th>
                    <th>Survey No</th>
                    <th>Area Utilized</th>
                    <th>Balance Area</th>
                    <th>Document Hash</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedBlock.payload.utilisationHistory.map((u, i) => (
                    <tr key={i}>
                      <td>{u.date}</td>
                      <td>{u.utiliserName}</td>
                      <td>{u.usedAt}, {u.usedAtDistrict}, {u.usedAtState}</td>
                      <td>{u.surveyNo}</td>
                      <td>{u.areaUtilizedSqm} sqm</td>
                      <td>{u.balanceAreaSqm} sqm</td>
                      <td>
                        <span className={styles.hashTruncate} onClick={() => toggleHash(`util-${i}`)}>
                          {truncateHash(u.documentHash, `util-${i}`)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className={styles.modalActions}>
              <button className={styles.closeBtn} onClick={() => setDetailsOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Checklist Modal */}
      {checklistOpen && selectedBlock && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalOptimized}>
            <h3 className={styles.modalHeading}>Validation Checklist</h3>

            {/* Overall Progress Bar */}
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{ width: `${(completedSteps / totalSteps) * 100}%` }}
              ></div>
            </div>
            <p className={styles.progressText}>
              {completedSteps} / {totalSteps} Steps Completed
            </p>

            {/* Two-column Checklist */}
            <div className={styles.checklistGrid}>
              {checklistItems.map((item) => (
                <div key={item.key} className={styles.checklistItem}>
                  <label>
                    <input
                      type="checkbox"
                      checked={checklist[item.key]}
                      onChange={(e) =>
                        setChecklist({ ...checklist, [item.key]: e.target.checked })
                      }
                    />
                    <span className={styles.checklistLabel}>{item.label}</span>
                    <span className={styles.tooltip}>{getChecklistTooltip(item.key)}</span>
                  </label>
                </div>
              ))}
            </div>

            {/* Signature Section */}
            <div className={styles.signatureBox}>
              <label>
                Enter Private Key to Sign:
                <input
                  type="password"
                  value={privateKey}
                  onChange={(e) => setPrivateKey(e.target.value)}
                  className={styles.privateKeyInput}
                />
              </label>
              <button className={styles.generateBtn} onClick={generateSignature}>
                Generate Signature
              </button>
              {signature && (
                <p className={styles.signatureText}>
                  Signature: {signature.slice(0, 20)}... (truncated)
                </p>
              )}
            </div>

            {/* Actions */}
            <div className={styles.modalActions}>
              <button className={styles.closeBtn} onClick={() => setChecklistOpen(false)}>
                Cancel
              </button>
              <button className={styles.validateBtn} onClick={confirmValidation}>
                Confirm Validation
              </button>
            </div>
          </div>
        </div>
      )}




    </div>
  );
}
